const extensions = require.context(
  '../../ext',
  true,
  /\.\/[\w-]+\/[\w-]+\/index\.js/
)

const extInfos = extensions.keys().map(fileName => {
  const config = extensions(fileName)
  const ns = fileName.replace(/^\./, 'ext').replace(/\/index\.js$/, '')
  return {
    namespace: ns,
    config: config,
  }
})

export default extInfos
